import React from "react";
import { Upload, Icon, Input, Row, Col, message, Tabs, Button } from 'antd';
import { createUuid } from '../../../../utils/NHCore';
const TabPane = Tabs.TabPane;

class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewVisible: false,
            previewImage: '',
            fileList: [],
            err: false,
            formData: {
                activeKey: 'file_tab',
                href: undefined,
                attachmentId: undefined,
                title: undefined,
                content: undefined
            }
        }
    }

    validateFields = (callback) => {
        let { err, formData,fileList } = this.state;
        if (!formData.fileName) {
            err = true;
            message.error("文件名不能为空！");
        }
        if (formData.activeKey == 'src_tab') {
            if (!formData.href) {
                err = true;
                message.error("链接地址不能为空！");
            }
        } else {
            if(fileList.length==0){
                err = true;
                message.error("请上传文件！");
            }else{
                let {response,status} = fileList[0];
                if(status==="done" && response && response.data && response.data.ssbh){
                    formData['attachmentId'] = response.data.ssbh;
                }else{
                    err = true;
                    message.error("请上传文件！");
                }
            }
        }
        if (callback) {
            callback(err, formData);
        }
    }
    changeNumber = (name, value) => {
        let formData = this.state.formData;
        formData[name] = value;
        this.setState(formData);
    }
    handleChange = ({ fileList }) => {
        console.log(fileList);
        this.setState({ fileList });
    }

    beforeUpload=(file)=>{
        console.log(file);
        return true;
    }

    render() {
        const { previewVisible, previewImage, fileList } = this.state;
        const uploadProps = {
            name: 'file',
            action: 'zuul/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },
            beforeUpload: this.beforeUpload,
        }
        const footerDiv = <div>
            <Row style={{ marginBottom: 20 }}>
                <Col span={8} style={{ textAlign: 'right' }}><font color='red'>*</font>文件名称：</Col>
                <Col span={12}><Input value={this.state.formData.fileName} onChange={(e) => {
                    this.changeNumber("fileName", e.target.value);
                }} /></Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
                <Col span={8} style={{ textAlign: 'right' }}>文件标题：</Col>
                <Col span={12}><Input value={this.state.formData.title} onChange={(e) => {
                    this.changeNumber("title", e.target.value);
                }} /></Col>
            </Row>
        </div>
        return (
            <Tabs activeKey={this.state.formData.activeKey} onChange={(activeKey) => {
                this.changeNumber("activeKey", activeKey);
            }}>
                <TabPane tab="本地上传" key="file_tab">
                    <Row style={{ marginBottom: 20 }}>
                        <Col span={8} style={{ textAlign: 'right' }}><font color='red'>*</font>上传文件：</Col>
                        <Col span={12}>
                            <Upload {...uploadProps} fileList={fileList}
                                onChange={this.handleChange}>
                                {fileList.length > 0 ? null : <Button>
                                    <Icon type="upload" /> 上传
                                </Button>}
                            </Upload>
                        </Col>
                    </Row>
                    {footerDiv}
                </TabPane>
                <TabPane tab="文件链接" key="src_tab">
                    <Row style={{ marginBottom: 20 }}>
                        <Col span={8} style={{ textAlign: 'right' }}><font color='red'>*</font>文件链接：</Col>
                        <Col span={12}><Input value={this.state.formData.href} onChange={(e) => {
                            this.changeNumber("href", e.target.value);
                        }} /></Col>
                    </Row>
                    {footerDiv}
                </TabPane>
            </Tabs>
        );
    }
}


export default EditInitForm;


// WEBPACK FOOTER //
// ./components/common/NHUeditor/file/EditForm.js